/* hb-cards.js v2 (2026-10-13) - Havin Bag : cartes produit uniformisees + carres de variantes.
   Meme rendu que la v1, sans saccades au scroll :
   1. Analyse des couleurs pendant les temps morts du navigateur, une image a la fois.
   2. Canvas unique en mode "willReadFrequently" (pas de relecture GPU a chaque image).
   3. Couleurs memorisees (localStorage) : des la 2e page vue, aucun calcul ni telechargement.
   4. MutationObserver : ne reagit qu'a l'ajout de cartes produit, regroupe en 1 passage par image. */
(function () {
  try {
    var RX = /\b(Vegan Leather|Genuine Leather|Faux Suede|Suede|Leather|Washed|Buckle|Frosted|Studded|Beaded Shell|15\.6" Laptop Travel)\b\s*/g;
    var FLAG = '__hbCards';
    var KEY = 'hb-cards-colours-v1';

    var shortDesc = function (d) { return d.replace(RX, '').replace(/\s+/g, ' ').trim(); };

    /* ---------- colour cache (localStorage, fails silently) ---------- */
    var stored = {};
    try { stored = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { stored = {}; }
    if (Object.keys(stored).length > 800) stored = {};
    var saveTimer = 0;
    var persist = function () {
      if (saveTimer) return;
      saveTimer = setTimeout(function () {
        saveTimer = 0;
        try { localStorage.setItem(KEY, JSON.stringify(stored)); } catch (e) {}
      }, 1500);
    };
    var keyOf = function (src) { return String(src).replace(/^https?:/, ''); };

    /* ---------- idle-time queue: one heavy job at a time, outside scroll frames ---------- */
    var queue = [], waiting = false;
    var idle = window.requestIdleCallback
      ? function (cb) { window.requestIdleCallback(cb, { timeout: 1500 }); }
      : function (cb) { setTimeout(function () { cb({ didTimeout: true, timeRemaining: function () { return 0; } }); }, 60); };
    var pump = function () {
      if (waiting || !queue.length) return;
      waiting = true;
      idle(function (deadline) {
        waiting = false;
        do { queue.shift()(); } while (queue.length && !deadline.didTimeout && deadline.timeRemaining() > 6);
        pump();
      });
    };
    var later = function (job) { queue.push(job); pump(); };

    /* ---------- image analysis (same algorithm as v1) ---------- */
    var canvas = null, ctx = null;
    var analyse = function (im) {
      var w = im.naturalWidth, h = im.naturalHeight;
      if (!canvas) {
        canvas = document.createElement('canvas');
        ctx = canvas.getContext('2d', { willReadFrequently: true });
      }
      canvas.width = w; canvas.height = h;
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h); ctx.drawImage(im, 0, 0);
      var d = ctx.getImageData(0, 0, w, h).data, bs = [], i, j;
      for (i = 0; i < w; i += 2) bs.push(d[(w + i) * 4]);
      bs.sort(function (a, b) { return a - b; });
      var bg = bs[bs.length >> 1], R = [], G = [], B = [];
      for (j = Math.floor(h * .25); j < h * .85; j += 2) {
        for (i = Math.floor(w * .2); i < w * .8; i += 2) {
          var o = (j * w + i) * 4, mn = Math.min(d[o], d[o + 1], d[o + 2]);
          if (bg - mn > 45 || bg < 200) { R.push(d[o]); G.push(d[o + 1]); B.push(d[o + 2]); }
        }
      }
      var md = function (a) { a.sort(function (p, q) { return p - q; }); return a.length ? a[a.length >> 1] : 200; };
      return 'rgb(' + md(R) + ',' + md(G) + ',' + md(B) + ')';
    };

    var pending = {};
    var colour = function (src) {
      var k = keyOf(src);
      if (stored[k]) return Promise.resolve(stored[k]);
      if (pending[k]) return pending[k];
      return (pending[k] = new Promise(function (res) {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.decoding = 'async';
        im.onload = function () {
          later(function () {
            var col;
            try { col = analyse(im); stored[k] = col; persist(); } catch (e) { col = '#ccc'; }
            res(col);
          });
        };
        im.onerror = function () { res('#ccc'); };
        im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      }));
    };

    /* ---------- card build (identical to v1) ---------- */
    var build = function (card) {
      if (card[FLAG]) return;
      card[FLAG] = 1;
      var desc = card.querySelector('.card>.card__content .card__desc');
      if (desc && !desc.dataset.full) {
        var full = desc.textContent.trim();
        desc.dataset.full = full;
        desc.textContent = shortDesc(full);
        var a0 = desc.closest('a');
        if (a0) {
          var n = a0.querySelector('.card__name');
          a0.setAttribute('title', (n ? n.textContent.trim() + ' ' : '') + full);
        }
      }
      var link = card.querySelector('a.card__title-link, a.full-unstyled-link');
      if (!link) return;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
      if (!m) return;
      var info = card.querySelector('.card>.card__content .card__information');
      if (!info || info.querySelector('.hb-cards__sw')) return;
      var row = document.createElement('div');
      row.className = 'hb-cards__sw';
      info.appendChild(row);
      fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var oi = -1;
        p.options.forEach(function (o, i) { if (/colou?r/i.test(o.name)) oi = i; });
        var list = [], seen = {};
        p.variants.forEach(function (v) {
          var val = oi > -1 ? v.options[oi] : '';
          if (!seen[val]) {
            seen[val] = 1;
            list.push({ val: val, id: v.id, img: (v.featured_image && v.featured_image.src) || p.featured_image });
          }
        });
        var curImg = '', mediaImg = card.querySelector('.card__media img');
        if (mediaImg) curImg = (mediaImg.getAttribute('src') || '').split('?')[0].split('/').pop();
        var sel = 0;
        list.forEach(function (c, i) { if (c.img && c.img.split('?')[0].split('/').pop() === curImg) sel = i; });
        var MAX = 5;
        list.slice(0, MAX).forEach(function (c, i) {
          var a = document.createElement('a');
          a.href = '/products/' + p.handle + '?variant=' + c.id;
          a.title = c.val;
          a.setAttribute('aria-label', c.val);
          if (i === sel) a.setAttribute('aria-current', 'true');
          var sq = document.createElement('i');
          a.appendChild(sq);
          row.appendChild(a);
          if (c.img) colour(c.img).then(function (col) { sq.style.background = col; });
        });
        if (list.length > MAX) {
          var more = document.createElement('a');
          more.className = 'hb-cards__more';
          more.href = '/products/' + p.handle;
          more.textContent = '+' + (list.length - MAX);
          row.appendChild(more);
        }
      }).catch(function () {});
    };

    var all = function () {
      var l = document.querySelectorAll('.product-card-wrapper'), i;
      for (i = 0; i < l.length; i++) build(l[i]);
    };

    /* ---------- styles (identical to v1) ---------- */
    var CSS = '.product-card-wrapper .card__title-swatches{display:none!important}.product-card-wrapper .card>.card__content .card__title-row{display:block!important}.product-card-wrapper .card>.card__content,.product-card-wrapper .card>.card__content .card__information,.product-card-wrapper .card>.card__content .card__title-row,.product-card-wrapper .card>.card__content .card__heading{min-width:0!important;max-width:100%!important}.product-card-wrapper .card>.card__content .card__title-link{display:flex!important;align-items:baseline;gap:0.3em;white-space:nowrap;overflow:hidden;max-width:100%}.product-card-wrapper .card>.card__content .card__name,.product-card-wrapper .card>.card__content .card__desc{font-size:13px!important;font-weight:600!important;color:rgb(33,31,27)!important;letter-spacing:0.01em!important;line-height:1.4!important;font-family:inherit!important;text-transform:none!important}.product-card-wrapper .card>.card__content .card__name{flex:0 0 auto;display:inline!important;overflow:visible!important;max-width:none!important;padding-right:0!important}.product-card-wrapper .card>.card__content .card__desc{flex:1 1 auto;min-width:0;margin-top:0!important;display:block;overflow:hidden!important;text-overflow:ellipsis!important}.hb-cards__sw{display:flex;align-items:center;margin:6px 0 0 -4px;min-height:24px;position:relative;z-index:2}.hb-cards__sw a{position:relative;display:flex;align-items:center;justify-content:center;width:24px;height:24px;flex:0 0 24px;text-decoration:none}.hb-cards__sw a i{display:block;width:16px;height:16px;background:#ddd;box-shadow:inset 0 0 0 1px rgba(33,31,27,.12)}.hb-cards__sw a[aria-current=true]::after{content:"";position:absolute;left:4px;right:4px;bottom:1px;height:1px;background:#211F1B}.hb-cards__more{font-size:11px;color:rgba(33,31,27,.6);margin-left:6px;letter-spacing:0;text-decoration:none;flex:0 0 auto;width:auto!important}';
    if (!document.getElementById('hb-cards-css')) {
      var st = document.createElement('style');
      st.id = 'hb-cards-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }

    /* ---------- start-up + watching for new cards (batched, one pass per frame) ---------- */
    var scheduled = false;
    var scheduleAll = function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; all(); });
    };
    all();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('.product-card-wrapper') || n.querySelector('.product-card-wrapper'))) {
            scheduleAll();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', all);
  } catch (e) {}
})();
